export interface GetHelpTopicDetailByTopicInfoResponse {
  CompanyInfo: CompanyInfo
  HelpTopicDetail: HelpTopicDetail
  CompanyHelpTopicDetails: CompanyHelpTopicDetail[]
  TextApproveList: TextApproveList[]
}

export interface CompanyInfo {
  CompanyId: number
  CompanyName: string
  eMail: string
  PhoneNo: string
  WebUrl: string
  TopicList: any[]
}

export interface HelpTopicDetail {
  Id: number
  CompanyId: number
  HelpTopicHeader: string
  Description: any
  Token: string
}

export interface CompanyHelpTopicDetail {
  Id: number
  MainHelpCompanyId: number
  LineTypeInt: LineTypeEnum
  LineTypeStr: string
  ImageUrl: any
  ShowOrder: number
  ImageShowPercentage: any
  IsTextHtml: boolean
  Text: any
  YoutTubeUrl: string
  Header: any
}

export enum LineTypeEnum {
  Header = 1,
  Text = 2,
  SimplePic = 3,
  PicLeftTextRight = 4,
  PicRightTextLeft = 5,
  OneLineVideo = 10
}

export interface TextApproveList {
  Id: number
  ApproveTextHeader: string
  ApproveTextContent: string
}
